import React from "react";
import classes from "./Logo.module.css";
import LogoImg from "../../assets/images/logo.svg";

function Logo() {
  return <img className={classes.Logo} src={LogoImg} alt="African Hub Logo" />;
}

export default Logo;
